import React, { useEffect, useState } from "react";
import { useRouter } from "next/router";

import { getDirectusFAQs } from "api/requests/directus/getDirectusFAQs";
import { FAQ } from "custom-types/Directus";
import useDomainCountryCode from "hooks/useDomainCountryCode";
import parseNextRouterAsPath from "utils/parseNextRouterAsPath";

import FAQs from "components/FAQ";

type Props = {
  collection: string;
  className?: string;
  initialShowPanel?: boolean;
  onClick?: () => void;
};

const DirectusFAQs = ({
  className,
  collection,
  initialShowPanel,
  onClick,
}: Props) => {
  const { asPath } = useRouter();
  const { path: slug } = parseNextRouterAsPath(asPath);

  const [directusFAQData, setDirectusFAQData] = useState<FAQ["faqs"]>([]);
  const countryCode = useDomainCountryCode();

  useEffect(() => {
    getDirectusFAQs(collection, slug, countryCode).then((data) => {
      if (!data) {
        setDirectusFAQData([]);
      }
      setDirectusFAQData(data);
    });
  }, []);

  return (
    <FAQs
      data={directusFAQData}
      onEntryClick={onClick}
      className={className}
      initialShowPanel={initialShowPanel}
    />
  );
};

export default DirectusFAQs;
